import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import { LuAlarmClock } from "react-icons/lu";
import EventFinished from "src/components/EventFinished";
import { useWindowWidth } from "src/utils/windowUtils";
import AddToCalendar from "src/components/AddToCalendar/AddToCalendar";
import CalendarPlusIcon from "src/components/AddToCalendar/CalendarPlusIcon";

const GPFreePlay2026 = () => {
  const { t, i18n } = useTranslation();
  const windowWidth = useWindowWidth();

  // Determine the correct hero image based on screen size and language
  const isMobile = windowWidth < 992;
  const lang = i18n.language.toUpperCase();

  const heroImagePath = isMobile
    ? `promotions/gaming-machines/gp-free-play-2026/GP-mobile-hero-image-${lang}.png`
    : `promotions/gaming-machines/gp-free-play-2026/GP-hero-image-2400x800px-${lang}.jpg`;

  return (
    <GPFreePlay2026Div>
      <EventFinished scheduleKeyName="gpFreePlay2026" eventType="promotion" />
      <Hero
        bgImage={heroImagePath}
        buttonSettings={null}
        imageAlt={t("gpFreePlay2026.hero.title")}
        showArrow
        arrowBounce
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("gpFreePlay2026.content.subtitle")}
            text={t("gpFreePlay2026.content.text")}
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0 text-box p-3 mb-4" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("gpFreePlay2026.content.description")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="periods pb-3">
            <Col>
              <LuAlarmClock />
              <TitleSection
                as={"h3"}
                title={t("gpFreePlay2026.content.giveawayPeriods.title")}
                text={t("gpFreePlay2026.content.giveawayPeriods.text")}
                className="py-0"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DatesWrapper>
                <span>
                  {t("gpFreePlay2026.content.giveawayPeriods.dates.friday")}{" "}
                  <span className="inline-calendar-icon">
                    <AddToCalendar
                      name={t("gpFreePlay2026.hero.title")}
                      description={t("gpFreePlay2026.content.description")}
                      location="Playground, Kahnawake, QC J0L 1B0"
                      startDate="2026-05-22"
                      startTime="18:00"
                      endDate="2026-05-22"
                      endTime="22:00"
                      timeZone="America/Toronto"
                      ariaLabel={t("calendar.addToCalendar.label")}
                    >
                      <CalendarPlusIcon />
                    </AddToCalendar>
                  </span>
                </span>
                <span> & </span>
                <span>
                  {t("gpFreePlay2026.content.giveawayPeriods.dates.saturday")}{" "}
                  <span className="inline-calendar-icon">
                    <AddToCalendar
                      name={t("gpFreePlay2026.hero.title")}
                      description={t("gpFreePlay2026.content.description")}
                      location="Playground, Kahnawake, QC J0L 1B0"
                      startDate="2026-05-23"
                      startTime="18:00"
                      endDate="2026-05-23"
                      endTime="22:00"
                      timeZone="America/Toronto"
                      ariaLabel={t("calendar.addToCalendar.label")}
                    >
                      <CalendarPlusIcon />
                    </AddToCalendar>
                  </span>
                </span>
                <span>, {t("gpFreePlay2026.content.giveawayPeriods.dates.year")}</span>
              </DatesWrapper>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </GPFreePlay2026Div>
  );
};

const GPFreePlay2026Div = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_container {
    min-height: 800px;
  }
  .hero_text_container {
    /* display: none; */
  }
  .small {
    text-align: center;
  }
  strong {
    color: #7bfff9;
  }
  @media (max-width: 991px) {
    .hero_container {
      min-height: 500px;
      background-position: center top !important;
    }
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .text-box {
    background-color: #2c363b;
    border-radius: 10px;
  }
  p {
    font-size: 1.22rem;
    text-align: center;
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
  div.periods {
    text-align: center;
    svg {
      margin: 20px 0 10px;
      color: var(--red);
      font-size: 40px;
    }
  }
`;

const DatesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  margin-top: 1rem;
  font-size: 1.22rem;

  > span {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
  }

  .inline-calendar-icon {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;

    .dropdown {
      display: inline-flex !important;
      align-items: center;

      > span[aria-label] {
        background: var(--fc-tournament-satellite);
        padding: 0.15rem 0.2rem;
        border-radius: 5px;

        span {
          gap: 0.15rem;

          svg {
            font-size: 0.9rem;
          }

          .plus-icon {
            font-size: 0.5rem;
            color: var(--white);
          }
        }
      }
    }
  }
`;

export default GPFreePlay2026;
